import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../../layout/component-layout/sign-in/sign-in.component';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { BehaviorSubject, filter, takeUntil } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { FormForumComponent } from './form-forum/form-forum.component';
import { MAIN_CATEGORIES } from './tab-forum.interfaces';
import { Location } from '@angular/common';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-tab-forum',
  templateUrl: './tab-forum.component.html',
  styleUrls: ['./tab-forum.component.scss'],
})
export class TabForumComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  @ViewChild('forumForm') forumForm: FormForumComponent;
  @ViewChild('SignIn', { static: true }) signIn: SignInComponent;

  openTag: boolean = false;
  openAll: boolean = false;
  currentUrl: string = '/forum'
  constructor(
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private clipboard: Clipboard,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    public roleSer: RoleService,
    private store: Store<AppState>,
    private seo: SeoService,
    private location: Location,
    private commonService: CommonService
  ) {
  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;
  categories: any = [];
  darkModeKey: string = 'darkMode';
  forums: any = {
    categoryLoad: false,
    list: {},
    popular: [],
  };


  categoriesSelect: any = [];
  forum: any = {
    categoryId: '',
  };


  mainCategories = MAIN_CATEGORIES;
  activeMainCategory: string = 'All';

  imgUrl: string = environment.ImageUrl;

  menu: boolean = false;
  public isUserDisabled: boolean = false;

  appUserLevel: any = 0;

  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      const category = params['category']
      if (category) {
        if (this.mainCategories.includes(category))
          this.activeMainCategory = category;
      }
    });
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.isUserDisabled = user?.isDisabled;
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((res: User) => {
        this.appUserLevel = res.level;
      });

    // document.getElementsByTagName("body")[0].style.setProperty('background-color', 'rgb(105, 44, 189, 0.2)', 'important');

    this.isLoading = true;

    // this.showDetail('forum');
    this.sharedService.initTopic$.subscribe((e: any) => {
      // if (e.type == 'topic') this.forumFormModal(this.forumForm);
      if (e.type == 'menu') this.menu = !this.menu;
      if (e.type == 'search') {
        this.initForums(1, e.value.toLowerCase());
      }
      if (e.type == 'init') {
        this.initForums(1);
      }
    });


    // if (this.sharedService.isBrowser()) {
    this.seo.update({
      title: 'Forum',
      description: 'Join the discussion in our forum. Share your thoughts, ask questions, and connect with other members of the community.',
      main_title: ' | BEST SERVICES SG'
    });
    this.seo.updateSchema('forum')
    // }
  }

  ngAfterViewInit(): void {
    this.initCategories();
    this.initForums();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;
    return user.id == data.createdBy;
  };

  mainCategoryChange(event: any, value: string) {
    event.preventDefault();
    this.activeMainCategory = value;
    this.location.replaceState(`/forum?category=${value}`)
    this.initForums(1);
  }

  startCountdown(item: any): void {
    item.interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(item.endDate).getTime() - now;

      if (distance < 0) {
        clearInterval(item.interval);
        item.remainingTime = "Time's up!";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      item.remainingTime =
        (days > 0 ? days + 'd ' : '') +
        (hours < 10 ? '0' + hours : hours) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds);
    }, 1000);
  }


  isDarkMode(): boolean {
    return localStorage.getItem(this.darkModeKey) === 'true';
  }

  setDarkMode(isDark: boolean): void {
    if (isDark) {
      document.body.classList.add('dark-mode');
      localStorage.setItem(this.darkModeKey, 'true');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem(this.darkModeKey, 'false');
    }
  }

  getPages = () =>
    this.local.getPages(this.forums.currentPage, this.forums.lastPage);

  initForums(page: number = 1, search: string = '') {
    this.isLoading = true;
    const mainCategories =
      this.activeMainCategory == 'All' ? [] : [this.activeMainCategory];
    this.auth
      .marketplace_forum_shop_fetch(
        '',
        page,
        this.forum.categoryId,
        mainCategories,
        this.activeMainCategory == 'All',
        search
      )

      .subscribe((response: any) => {
        const result = response.body;
        this.forums.currentPage = response.body.currentPage;
        this.forums.lastPage = response.body.lastPage;

        this.mainCategories.map((category: string) => {
          this.forums.list[category] = [];
        });
        // Process each forum item
        this.forums.popular = [];
        result.data.map((row: any) => {
          row.user = row.user || {};
          row.replyText = '';

          row.createdAtText = this.local.timeAgo(row.createdAt);
          row.visitor = 0;
          row.showReply = false;

          if (row.repliesCount > 4) {
            this.forums.popular.push(row);
          }
          // Assign to corresponding category
          if (this.forums.list[row.category]) {
            this.forums.list[row.category].push(row);
          }
        });
        this.isLoading = false;
      });
  }

  initCategories() {
    this.auth.forum_category_fetch().subscribe((response: any) => {
      this.categories = response.body;
      this.categories.map((row: any) => {
        this.categoriesSelect.push({
          value: row.id.toString(),
          label: row.name,
        });
      });
    });
  }

  handleSelectCategory(categoryId: any = '') {
    if (categoryId == '') this.forums.categoryLoad = false;
    else this.forums.categoryLoad = true;

    if (this.forum.categoryId == categoryId) {
      this.forums.categoryLoad = false;
      this.forum.categoryId = '';
    } else this.forum.categoryId = categoryId;

    this.initForums(1);
  }

  forumFormModal(item?: any) {
    this.forumForm.forumFormModal(item)
  }


  deletePost(event: any, id: number) {
    this.forumForm.deletePost(event, id)
  }

  scrollTo(id: string) {
    this.local.scrollTo(id);
  }

  loginHere() {
    this.signIn.loginStage = '';
    this.signIn.openSignInPopup();
  }



  openDetailPost(item: any) {
    this.router.navigate(['/forum', item.slug])
  }

  async handleShowOptionForum(index: number) {
    if (this.forums?.list) {
      await Promise.all(
        this.forums?.list?.map((row: any, i: number) => {
          if (index != i) row.showOption = false;
          // row.isEdit = false
        })
      ).then(() => {
        this.forums.list[index].showOption = !this.forums.list[index].showOption;
      });
    }
  }

  handlePinForum(e: any, item: any) {
    e.preventDefault();
    item.showOption = false;
    this.auth.forum_pin(item.id).subscribe(() => {
      item.isPinned = !item.isPinned;
      this.initForums();
      this.toastr.success('Forum Pinned Succesfully');
    });
  }

  copyLink(type: string, item: any) {
    let currentUrl = window.location.href.split('#')[0];
    currentUrl = currentUrl + '/forum';
    this.clipboard.copy(`${currentUrl}/${item.uuid}`);
    this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
  }

  hasCheckedForum(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  likeForum(forumId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    if (this.isUserDisabled)
      return this.toastr.error('Your account is muted !');
    const payload = {
      userId: this.appUserId,
      forumId: forumId,
    };

    if (this.hasCheckedForum(data.forumLikes))
      data.forumLikes = data.forumLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.forumLikes = [...data.forumLikes, payload];

    this.auth.forum_likes(payload).subscribe();
  }

  handleReport(id: any, category = 'forum') {
    this.forumForm.handleReport(id, category)
  }

  handleMuteForum(item: any) {
    this.auth
      .forum_mute({
        forumId: item.id,
      })

      .subscribe(
        () => {
          item.isMuted = !item.isMuted;
          this.toastr.success('Forum muted successfully');
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }
}
